import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_OrderOfservice = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_OrderOfservice' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>Order of Service</h3></center></p>
                {/* <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServedName' name='txtPersonServedName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Start Time: </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>End Time:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Code:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtStartTime' name='txtStartTime' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='time' id='txtEndTime' name='txtEndTime' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtServiceCode' name='txtServiceCode' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Units:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Place of Service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtUnits' name='txtUnits' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPlaceOfService' name='txtPlaceOfService' className='add-only' /></td>
                    </tr>
                </table> */}

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eligibility</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEligibility_1' name='cbEligibility_1' className='add-only' value='1' /> The consumer is a Medicaid/Peachcare/Amerigroup Recipient (or is eligible)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEligibility_2' name='cbEligibility_2' className='add-only' value='2' /> The consumer is uninsured, underinsured or otherwise indigent</td>
                    </tr>
                </table>

                <p className='w-750'><h3><b>-AND-</b></h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnd_3' name='cbAnd_3' className='add-only' value='1' /> The consumer is over the age of 21</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnd_4' name='cbAnd_4' className='add-only' value='2' /> The consumer is between the ages of 0 and 5</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnd_5' name='cbAnd_5' className='add-only' value='3' /> The consumer is between the ages of 5 and 21</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnd_6' name='cbAnd_6' className='add-only' value='4' /> DSM-5 diagnosis (confirmed or suspected) and symptoms of SED and /or Substance Related Disorder</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnd_7' name='cbAnd_7' className='add-only' value='5' /> The consumer is not receiving CORE/Specialty Services from another agency</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAnd_8' name='cbAnd_8' className='add-only' value='6' /> The consumer is ONLY receiving medication management from another agency</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Services Ordered/Requested/Recommended</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_1' name='cbServicesOrderedRequested_1' className='add-only' value='1' /> Diagnostic Assessments</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_2' name='cbServicesOrderedRequested_2' className='add-only' value='2' /> Psychiatric Treatment</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_3' name='cbServicesOrderedRequested_3' className='add-only' value='3' /> Nursing Assessment & Health Services
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_4' name='cbServicesOrderedRequested_4' className='add-only' value='4' /> Psychological Testing</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_5' name='cbServicesOrderedRequested_5' className='add-only' value='5' /> Individual Outpatient Counseling</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_6' name='cbServicesOrderedRequested_6' className='add-only' value='6' /> Pharmacy & Lab</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_7' name='cbServicesOrderedRequested_7' className='add-only' value='7' /> Family Outpatient Counseling</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_8' name='cbServicesOrderedRequested_8' className='add-only' value='8' /> Crisis Intervention</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_9' name='cbServicesOrderedRequested_9' className='add-only' value='9' /> Group Outpatient Counseling</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_10' name='cbServicesOrderedRequested_10' className='add-only' value='10' /> Case Management Services</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_11' name='cbServicesOrderedRequested_11' className='add-only' value='11' /> Community Support Individual (CSI)</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_12' name='cbServicesOrderedRequested_12' className='add-only' value='12' /> Addictive Disease Support Services</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_13' name='cbServicesOrderedRequested_13' className='add-only' value='13' /> Family Skill Training </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_14' name='cbServicesOrderedRequested_14' className='add-only' value='14' /> Psychosocial Rehabilitation (Individual)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_15' name='cbServicesOrderedRequested_15' className='add-only' value='15' /> Group Training</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_16' name='cbServicesOrderedRequested_16' className='add-only' value='16' /> Peer Support Individual</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_17' name='cbServicesOrderedRequested_17' className='add-only' value='17' /> Intensive Family Intervention (IFI)</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServicesOrderedRequested_18' name='cbServicesOrderedRequested_18' className='add-only' value='18' /> Peer Support Group</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServicesOrderedRequested_19' name='cbServicesOrderedRequested_19' className='add-only' value='19' /> Behavioral Health Assessment/Service Plan Development</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServicesOrderedRequested_20' name='cbServicesOrderedRequested_20' className='add-only' value='20' /> Other &nbsp;
                            <input type='text' id='txtServicesOrderdRequested' name='txtServicesOrderdRequested' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Information:</span>
                    <textarea id='txtAdditionalInformation' name='txtAdditionalInformation' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Order Expires: </span>
                    <input type='text' id='txtOrderExpires' name='txtOrderExpires' className='add-only' /> <br />
                    <input type='radio' id='rbOrderExpires_1' name='rbOrderExpires' className='add-only' value='Verbal'/> Verbal Order &nbsp;
                    <input type='radio' id='rbOrderExpires_2' name='rbOrderExpires' className='add-only' value='Telephone'/> Telephone Order &nbsp;
                    <input type='radio' id='rbOrderExpires_3' name='rbOrderExpires' className='add-only' value='OrderReadBack'/> Order Read Back and Verified </p>

                    
                {/* <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Appropriately Licensed Practitioner & Credentials</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Appropriately Licensed Practitioner & Credentials</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table> */}





            </div>
        </form>

    )
}  
